<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>作品管理</el-breadcrumb-item>
      <el-breadcrumb-item>作品查看</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width:360px !important;margin-right: 20px;">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项名称" clearable
            @change="selectGettrack(queryInfo.MatchID)" style="width:360px !important;">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName"
              :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-right:150px;">
          <el-select v-model="queryInfo.TrackID" placeholder="请选择赛道" clearable style="width:360px !important;">
            <el-option v-for="item in trackNameoptions" :key="item.TrackID" :label="item.TrackName"
              :value="item.TrackID" @change="getProjectList(1)">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="queryInfo.UploadAnmFile" placeholder="匿名作品" clearable>
            <el-option v-for="item in UploadAnmFileOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入搜索内容" v-model="queryInfo.SearchContent" clearable @clear="getProjectList(1)">
          </el-input>
        </el-col>
        <!-- <el-col :span="4">
          <el-input
            placeholder="请输入作品编号"
            v-model="queryInfo.ItemNo"
            clearable
            @clear="getProjectList(1)"
          >
          </el-input>
        </el-col> -->
        <el-col :span="2">
          <el-button icon="el-icon-search" type="primary" @click="getProjectList(1)">搜索</el-button>
        </el-col>
        <el-col :span="1">
          <el-button icon="el-icon-download" type="success" @click="doDown">导出</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称"> </el-table-column>
        <el-table-column prop="TrackName" label="赛道"> </el-table-column>
        <el-table-column prop="ItemNo" label="作品编号"> </el-table-column>
        <el-table-column prop="EntriesName" label="作品名称"> </el-table-column>
        <el-table-column prop="LeadCadName" label="负责人" width="60">
        </el-table-column>
        <el-table-column prop="CellPhoneNum" label="手机号" width="100"> </el-table-column>
        <el-table-column prop="School" label="所属学校"> </el-table-column>
        <el-table-column prop="Departments" label="学校院系"> </el-table-column>
        <el-table-column prop="JudgesGroupName" label="评委小组" width="70">
        </el-table-column>
        <el-table-column prop="EntriesFiles" label="作品" width="50">
          <template slot-scope="scope">
            <!-- <a
              :href="item.ServerUrl + item.FileName"
              target="_blank"
              v-for="(item, index) in scope.row.EntriesFiles"
              :key="index"
              style="text-decoration: none; color: #666"
            >
              {{ item.OldFileName  }} {{(scope.row.EntriesFiles.length > 1) ? ' |' : ''}}
            </a> -->
            <a style="color:#409Eff; text-decoration: underline; cursor: pointer;"
              @click="showProject(scope.row)">详情</a>
          </template>
        </el-table-column>
        <el-table-column prop="UploadAnmFile" label="匿名作品" width="75">
          <template slot-scope="scope">
            <div>
              <el-tag type="success" v-if="scope.row.UploadAnmFile === 1" size="small">已上传</el-tag>
              <el-tag type="danger" v-if="scope.row.UploadAnmFile === 2" size="small">未上传</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注">
          <template slot-scope="scope">
            <span v-if="scope.row.Remark">{{ scope.row.Remark }}</span>
            <span v-else style="color: #999;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="SubDate" label="提交日期" :formatter="dataFormat" width="150">
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showDialogVisible(scope.row)"
              circle></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteCreate(scope.row.EntriesID)"
              circle></el-button>
            <el-button type="warning" icon="el-icon-edit-outline" size="mini" @click="showRemarkDialog(scope.row)"
              circle></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
      <!-- 修改 -->
      <el-dialog title="修改作品" :visible.sync="editDialogVisible" width="30%" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="赛项名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" placeholder="请选择赛项名称" @change="selectGettrack(editForm.MatchID)"
              style="width:370px !important;">
              <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName"
                :value="item.MatchID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道" prop="TrackID">
            <el-select v-model="editForm.TrackID" style="width:370px !important;" placeholder="请选择赛道">
              <el-option v-for="item in trackNameoptions" :key="item.TrackID" :label="item.TrackName"
                :value="item.TrackID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="作品名称" prop="EntriesName">
            <el-input v-model="editForm.EntriesName"></el-input>
          </el-form-item>

          <el-form-item label="负责人姓名" prop="LeadCadName">
            <el-input v-model="editForm.LeadCadName"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="Gender">
            <el-select v-model="editForm.Gender" placeholder="请选择性别" clearable>
              <el-option v-for="item in Genderoptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="CellPhoneNum">
            <el-input v-model="editForm.CellPhoneNum"></el-input>
          </el-form-item>
          <el-form-item label="所属学校" prop="School">
            <el-input v-model="editForm.School"></el-input>
          </el-form-item>
          <el-form-item label="学校院系" prop="Departments">
            <el-input v-model="editForm.Departments"></el-input>
          </el-form-item>
          <!-- <el-form-item label="项目资料" prop="ProjectData">
            <el-input v-model="editForm.ProjectData"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 项目资料查看 -->
      <el-dialog title="作品资料查看" :visible.sync="viewDialogVisible" width="50%">
        <el-table :data="ProjectData" style="width: 100%" class="mttop">
          <el-table-column prop="OldFileName" label="文件名称">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.ServerUrl + scope.row.FileName" target="_blank" class="filename">{{
                  scope.row.OldFileName }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="FileSize" label="文件大小">
            <template slot-scope="scope">
              <div>
                {{ scope.row.FileSize.toFixed(2) + 'KB' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="FileType" label="文件类型">
            <template slot-scope="scope">
              <div>
                {{ scope.row.FileType === 1 ? '普通文件' : '匿名文件' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="文件查看">
            <template slot-scope="scope">
              <div>
                <el-link :href="scope.row.ServerUrl + scope.row.FileName" target="_blank"
                  style="color:#409Eff;">点击查看</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 备注编辑弹窗 -->
      <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" width="30%" @close="remarkDialogClose">
        <el-form :model="remarkForm" ref="remarkFormRef" label-width="80px">
          <el-form-item label="作品名称">
            <span>{{ currentRow ? currentRow.EntriesName : '' }}</span>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input type="textarea" v-model="remarkForm.Remark" :rows="4" placeholder="请输入备注信息" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="remarkDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveRemark">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项名称
        MatchID: '',
        // 赛道名称
        trackName: '',
        UploadAnmFile: '',
        SearchContent: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      addForm: {
        matchName: '',
        trackName: '',
        group: '',
        field: [],
        judges: []
      },
      // 修改表单
      editForm: {},
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛道',
            trigger: 'change'
          }
        ],
        TrackID: [
          {
            required: true,
            message: '请选择赛道',
            trigger: 'change'
          }
        ],
        EntriesName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        LeadCadName: [
          {
            required: true,
            message: '请输入负责人姓名',
            trigger: 'blur'
          }
        ],
        Gender: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        CellPhoneNum: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }
        ],
        School: [
          {
            required: true,
            message: '请输入所属学校',
            trigger: 'blur'
          }
        ],
        Departments: [
          {
            required: true,
            message: '请输入学校院系',
            trigger: 'blur'
          }
        ]
      },
      // 性别下拉选项
      Genderoptions: [
        {
          value: '1',
          label: '男'
        },
        {
          value: '2',
          label: '女'
        }
      ],
      // 是否上传匿名作品  上传匿名文件：0 全部，1 已上传，2 未上传
      UploadAnmFileOptions: [
        {
          value: '1',
          label: '已上传'
        },
        {
          value: '2',
          label: '未上传'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [],
      // 赛事下拉选项
      matchNameoptions: [],
      // 项目资料弹窗状态
      viewDialogVisible: false,
      // 项目资料
      ProjectData: [],
      // 备注弹窗状态
      remarkDialogVisible: false,
      // 备注表单
      remarkForm: {
        EntriesID: '',
        Remark: ''
      },
      // 当前编辑的行数据
      currentRow: null
    }
  },
  created() {
    //   默认获取列表
    this.getProjectList(1)
    // 默认获取赛事
    this.getAllMatch()
  },
  methods: {
    //   获取列表
    async getProjectList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get('/api/Entries/GetEntries', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.entries
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      // console.log(res)
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
    },
    // 下拉赛项获取对应赛道
    // selectType 0搜索 1 添加 2修改
    async selectGettrack(id) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.$set(this.queryInfo, 'TrackID', null)
      this.trackNameoptions = res.Data.tracks
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getProjectList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.getProjectList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.editForm = {
        MatchID: '',
        TrackID: '',
        EntriesName: '',
        LeadCadName: '',
        Gender: '',
        CellPhoneNum: '',
        School: '',
        Departments: ''
      }
      console.log(this.editForm)
      this.$refs.editFormRef.resetFields()
    },
    // 显示修改弹窗
    showDialogVisible(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editDialogVisible = true
      this.selectGettrack(this.editForm.MatchID, 2)
    },
    // 修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Entries/EditEntries',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getProjectList(1)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/Entries/DelEntries?entriesID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getProjectList(1)
    },
    // 显示项目资料弹窗
    async showProject(row) {
      // 项目资料发起请求
      const { data: res } = await this.$http.get(
        '/api/EntriesFile/GetEntriesFile',
        {
          params: {
            EntriesID: row.EntriesID,
            MatchID: row.MatchID
          }
        }
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.ProjectData = res.Data.entriesFiles
      // 打开弹窗
      this.viewDialogVisible = true
    },
    // 导出
    doDown() {
      this.$http
        .get('api/Entries/ExportEntries', { params: this.queryInfo })
        .then((res) => {
          const a = document.createElement('a')
          const href = res.data.Data
          a.href = href
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    // 显示备注弹窗
    showRemarkDialog(row) {
      this.currentRow = row
      this.remarkForm = {
        EntriesID: row.EntriesID,
        Remark: row.Remark || ''
      }
      this.remarkDialogVisible = true
    },

    // 关闭备注弹窗
    remarkDialogClose() {
      this.$refs.remarkFormRef && this.$refs.remarkFormRef.resetFields()
      this.currentRow = null
    },

    // 保存备注
    async saveRemark() {
      // 发起保存请求
      const { data: res } = await this.$http.post(
        '/api/Entries/EditRemark',
        this.remarkForm
      )

      if (res.StatusCode !== 1) {
        return this.$message.error(res.Msg || '保存失败')
      }

      this.$message.success('备注保存成功')
      this.remarkDialogVisible = false

      // 刷新列表
      this.getProjectList(this.queryInfo.pagenum)
    }
  }
}
</script>
<style lang="less" scoped>
.total_score {
  color: #999;
  padding: 9px 0;
}

.filename {
  text-decoration: none;
  color: #333;
}
</style>
